// #region imports

// --- Angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// --- RxJs
import { Observable, Subscription } from 'rxjs';

// --- 3rd Party
import { User as OidcUser } from 'oidc-client';

// --- Hs Code
import { AppService } from '../../../core/services/app.service';
import { OidcService, ActivationBaseService } from '../../../core/services/';
import { ResolvedTokenModel, Constants } from '../../../models';

// #endregion

@Component({
  selector: 'hs-registration-confirmed',
  templateUrl: './registration-confirmed.component.html',
  styleUrls: ['./registration-confirmed.component.scss']
})
export class RegistrationConfirmedComponent implements OnInit, OnDestroy {
  emailAddress$: Observable<string>;
  token$: Observable<string>;
  tokenResolutionResult$: Observable<ResolvedTokenModel>;

  private _activateSubscription: Subscription;
  private _routeParamSubscription: Subscription;
  private _identitySubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private activationService: ActivationBaseService,
    private oidcService: OidcService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.emailAddress$ = this.activationService.emailAddress$;
    this.token$ = this.activationService.token$;

    this.appService.setLoading(true);
    this._identitySubscription = this.oidcService.identity$.subscribe((identity: OidcUser) => {
      this.appService.setLoading(false);
      if (identity) {
        this.router.navigate(['/']);
      }
    });
    this.oidcService.getOidcUser();

    this._routeParamSubscription = this.route.paramMap.subscribe(params => this.activationService.resolveToken(params.get('token')));
  }

  ngOnDestroy() {
    this._routeParamSubscription.unsubscribe();
    this._routeParamSubscription = null;
    this._identitySubscription.unsubscribe();
    this._identitySubscription = null;
    this._activateSubscription.unsubscribe();
    this._activateSubscription = null;
  }

  onActivate(token: string) {
    if (!token) {
      return;
    }

    this.appService.setLoading(true);

    this._activateSubscription = this.activationService.activateAccount(token).subscribe((result) => {
      this.appService.setLoading(false);
      const otac = result.value;

      if (!otac) {
        return;
      }

      localStorage.setItem(Constants.INITIAL_ACTIVATION_KEY, 'true');

      this.oidcService.signInRedirect({
        extraQueryParams: {
          acr_values: 'otac:' + otac
        }
      });
    });
  }
}
